import { MenuList, DrawerContainer } from './NavigationDrawer.styles';
import { ListItemButton, ListItemIcon, ListItemText, Badge, Divider, Box } from '@mui/material';
import {
  BarChart as StatisticsIcon,
  GroupAdd as JoinTeamIcon,
  AddCircle as CreateTeamIcon,
  Notifications as NotificationsIcon,
  Info as InfoIcon,
  ContactMail as ContactIcon,
  Policy as PrivacyIcon,
  Description as TermsIcon,
  Article as BlogIcon,
  Login as LoginIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

/**
 * Sidebar navigation drawer with menu items.
 * Props:
 * - currentTeam: object or null
 * - unreadCount: number
 * - onMenuClick: function(action: string)
 */
function NavigationDrawer({ currentTeam, unreadCount, onMenuClick, mode = 'app' }) {
  const { t } = useTranslation();
  const isAdmin = currentTeam?.adminId === undefined ? false : true;

  if (mode === 'public') {
    return (
      <DrawerContainer role="presentation">
        <MenuList>
          <ListItemButton onClick={() => onMenuClick('blog')}>
            <ListItemIcon>
              <BlogIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('blog')} />
          </ListItemButton>

          <ListItemButton onClick={() => onMenuClick('about')}>
            <ListItemIcon>
              <InfoIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('aboutUsTitle')} />
          </ListItemButton>

          <ListItemButton onClick={() => onMenuClick('contact')}>
            <ListItemIcon>
              <ContactIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('contactTitle')} />
          </ListItemButton>

          <Divider component="hr" sx={{ my: 1, height: '2px', bgcolor: 'divider' }} />

          <ListItemButton onClick={() => onMenuClick('privacy')}>
            <ListItemIcon>
              <PrivacyIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('privacyPolicyTitle')} />
          </ListItemButton>

          <ListItemButton onClick={() => onMenuClick('terms')}>
            <ListItemIcon>
              <TermsIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('termsOfServiceTitle')} />
          </ListItemButton>

          <Divider />

          <ListItemButton onClick={() => onMenuClick('login')}>
            <ListItemIcon>
              <LoginIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={t('signIn')} />
          </ListItemButton>
        </MenuList>
        <Box sx={{ p: 2 }}>
          <LanguageSwitcher />
        </Box>
      </DrawerContainer>
    );
  }

  return (
    <DrawerContainer role="presentation">
      <MenuList>
        <ListItemButton onClick={() => onMenuClick('statistics')} disabled={!currentTeam}>
          <ListItemIcon>
            <StatisticsIcon color={currentTeam ? 'primary' : 'disabled'} />
          </ListItemIcon>
          <ListItemText primary={t('teamStatistics')} />
        </ListItemButton>

        <ListItemButton onClick={() => onMenuClick('joinTeam')}>
          <ListItemIcon>
            <JoinTeamIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={t('joinTeam')} />
        </ListItemButton>

        <ListItemButton onClick={() => onMenuClick('createTeam')}>
          <ListItemIcon>
            <CreateTeamIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={t('createTeam')} />
        </ListItemButton>

        {isAdmin && (
          <ListItemButton onClick={() => onMenuClick('notifications')}>
            <ListItemIcon>
              <Badge badgeContent={unreadCount} color="error">
                <NotificationsIcon color="primary" />
              </Badge>
            </ListItemIcon>
            <ListItemText primary={t('myNotifications')} />
          </ListItemButton>
        )}
  {/* Separator between functional items and legal pages (thicker) */}
  <Divider component="hr" sx={{ my: 1, height: '2px', bgcolor: 'divider' }} />

        {/* Legal pages */}
        <ListItemButton onClick={() => onMenuClick('about')}>
          <ListItemIcon>
            <InfoIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={t('aboutUsTitle')} />
        </ListItemButton>

        <ListItemButton onClick={() => onMenuClick('contact')}>
          <ListItemIcon>
            <ContactIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={t('contactTitle')} />
        </ListItemButton>

        <ListItemButton onClick={() => onMenuClick('privacy')}>
          <ListItemIcon>
            <PrivacyIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={t('privacyPolicyTitle')} />
        </ListItemButton>

        <ListItemButton onClick={() => onMenuClick('terms')}>
          <ListItemIcon>
            <TermsIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={t('termsOfServiceTitle')} />
        </ListItemButton>
      </MenuList>
    </DrawerContainer>
  );
}

export default NavigationDrawer;
